import { buildCommonFilters, embedFilter, numericMapItem } from '../sharedFilters'

const DATASET_KEY = 'alarms'

const commonFilters = buildCommonFilters(DATASET_KEY, {
  INSTALLATION: {},                                                  // units.description
  REGION: {},                                                        // regions.name
  MUNICIPALITY: {},                                                  // municipalities.name
  TENANT: {},                                                        // tenants.name
  STATUS: { column: 'view_alarm_status.alarm_status', label: 'Estatus' },
  SECTOR: false,                                                     // no se une sectors
  CENTER: false,                                                     // no se une centers
  USER: {},                                                          // users.id, via alarm_user
})

export default {
  key: DATASET_KEY,
  label: 'Alarmas',
  timeColumn: 'alarms.created',
  permission: { action: 'read_history', subject: 'Alarm' },

  tables: {
    alarms: ["id", "type", "created", "updated", "lat", "lng", "number_cad", "status_cad", "protocol", "id_router", "id_alarm_level"],
    alarms_levels: ["id", "level", "color", "description", "created_at", "updated_at"],
    type_alarms: ["id", "type", "description", "priority", "priority_comment", "priority_hour", "priority_minutes", "acronym", "color", "text_color", "icon", "created_at", "updated_at"],
    view_alarm_status: ["id_alarm", "alarm_status"],
    routers: ["id", "id_tenant", "lat", "lng"],
    units: ["id", "description", "id_region", "id_municipality", "active", "rems", "sirh"],
    regions: ["id", "name"],
    municipalities: ["id", "name"],
    tenants: ["id", "name"],
    alarm_user: ["id", "id_alarm", "id_user", "released", "status", "created_at", "updated_at"],
    users: ["id", "user", "name", "first_name", "second_name", "email", "id_profile"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  // Top N ranks by the label but restricts the chart through a filter param,
  // and the generic resolver looks for the id slot of the label's own table.
  // `type_alarms.id` has no param — the id travels in `alarms.type`, which the
  // `type` param already accepts (measured: `type=6,5` returns exactly the
  // Facial Recognition + Smart Detection rows).
  rankingTargets: {
    'type_alarms.description': { param: 'type', valueColumn: 'alarms.type' },
  },

  defaults: {
    field: 'units.description',
    field2: 'view_alarm_status.alarm_status',
  },

  // The user comes from alarm_user, the assignment history (one row per take,
  // release, review…). On, «Usuario» is the last assignee, the API's
  // alarmUser(); off, every assignment counts. See useCurrentStatus.
  currentStatus: {
    recordColumn: 'alarms.id',
    historyColumn: 'alarm_user.id',
    tables: ['alarm_user', 'users'],
    label: 'Solo última asignación',
  },

  // «Solo abiertos»: records whose current status is one of these are left
  // out. See useCurrentStatus.
  closedStatus: {
    column: 'view_alarm_status.alarm_status',
    values: ['attended', 'canceled'],
  },

  csvConfig: {
    withTables: 'alarms',
    columns: 'type_alarms.description,alarms.created,alarms.updated,alarms.number_cad,alarms.status_cad,alarms.protocol,alarms.lat,alarms.lng,view_alarm_status.alarm_status,alarms_levels.level,alarms_levels.description,units.description,units.rems,units.sirh,regions.name,municipalities.name,tenants.name',
    exceptColumns: 'alarms.id,alarms.id_router,alarms.id_user,alarms.id_alarm_level,alarms.data,alarms.smart_detection_id,alarms.smart_detection_timestamp',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'units.description', label: 'Inmueble' },
    { key: 'regions.name', label: 'Estado' },
    { key: 'municipalities.name', label: 'Municipio' },
    { key: 'tenants.name', label: 'Tenant' },
    { key: 'type_alarms.description', label: 'Tipo' },
    { key: 'view_alarm_status.alarm_status', label: 'Estatus' },
    { key: 'alarms_levels.level', label: 'Nivel' },
    { key: 'alarms_levels.description', label: 'Descripción del nivel' },
    { key: 'users.name', label: 'Usuario' },
    { key: 'alarms.number_cad', label: 'Número CAD' },
    { key: 'alarms.status_cad', label: 'Estatus CAD' },
    { key: 'alarms.protocol', label: 'Protocolo' },
    { key: 'alarms.created', label: 'Fecha de creación', defaultParams: { freq: '1mo' } },
    { key: 'alarms.updated', label: 'Fecha de actualización', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    ...commonFilters,
    embedFilter(DATASET_KEY, 'type_alarms.description', 'Tipo', 'type'),
    embedFilter(DATASET_KEY, 'alarms_levels.level', 'Nivel', 'level'),
    // `units.rems` / `units.sirh` are unsigned ints, so their options are cast to
    // strings by numericMapItem. Values and labels both come from the datasource.
    embedFilter(DATASET_KEY, 'units.rems', 'REMS', 'rems', {
      optionsOverrides: { mapItem: numericMapItem },
    }),
    embedFilter(DATASET_KEY, 'units.sirh', 'SIRH', 'sirh', {
      optionsOverrides: { mapItem: numericMapItem },
    }),
    {
      key: 'alarms_updated',
      label: 'Fecha de actualización',
      filterType: 'where-date',
      whereColumn: 'alarms.updated',
      optionsConfig: { type: 'date' },
    },
  ],

  dateGrouping: {
    column: 'alarms.created',
    presets: [
      { value: '1d', label: 'Día' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Año' },
    ],
  },
}
